module.exports = __webpack_public_path__ + "img/4B_old.e666be52.jpg";